import { SafeResourceUrl } from "@angular/platform-browser";

export class User {
  public email: string;
  public username: string;
  public first_name: string;
  public last_name: string;
  public company: string;
  public is_new_user: boolean;
  public current_cluster_id: number;
  public current_portfolio_id: number;
  public picture_b64: SafeResourceUrl;

  constructor() {}

  // initialize user
  init(email: string, username: string, first_name: string, last_name: string, company: string, is_new_user: boolean, current_portfolio_id?: number) {
    this.email = email;
    this.username = username;
    this.first_name = first_name;
    this.last_name = last_name;
    this.company = company;
    this.is_new_user = is_new_user;
    this.current_portfolio_id = current_portfolio_id ? current_portfolio_id : undefined;
  }

  // initialize user from JS object
  initFromData(data: any) {
    this.email = data.email;
    this.username = data.username;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.company = data.company;
    this.is_new_user = data.is_new_user;
    this.current_cluster_id = data.current_cluster_id ? data.current_cluster_id : undefined;
    this.current_portfolio_id = data.current_portfolio_id ? data.current_portfolio_id : undefined;
  }
}
